import { Data } from '@blade/std-lib'
import {
  type LoginMethod,
  type RegistrationMethod,
} from '@root/features/auth/authenticate'

import type { LoginPayload } from '@root/features/auth/authenticate'

export class Initial extends Data.TaggedClass('InitializationState/Initial') {}

export class Login extends Data.TaggedClass('InitializationState/Login')<{
  loginMethod: LoginMethod
}> {}

export class Otp extends Data.TaggedClass('InitializationState/Otp')<{
  loginPayload: LoginPayload
}> {}

export class Register extends Data.TaggedClass('InitializationState/Register')<{
  registrationMethod: RegistrationMethod
}> {}

export class InitializeStorage extends Data.TaggedClass(
  'InitializationState/InitializeStorage',
) {}

export class UnlockStorage extends Data.TaggedClass(
  'InitializationState/UnlockStorage',
) {}

export class Ready extends Data.TaggedClass('InitializationState/Ready') {}

export class Website extends Data.TaggedClass('InitializationState/Website') {}

export type State =
  | Initial
  | Login
  | Otp
  | Register
  | InitializeStorage
  | UnlockStorage
  | Ready
  | Website
